import { Link } from '@tanstack/react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { itemsHref } from '@/routes/items/-search-params';

interface BreadCrumbsProps {
  itemTags: Array<{
    keyTags: { id: number; name: string } | null;
    valueTags: { id: number; name: string };
  }>;
  uinsql: string;
}

export default function BreadCrumbs({ itemTags = [], uinsql }: BreadCrumbsProps) {
  const cat = itemTags.find((t) => t.keyTags?.id === 215)?.valueTags;
  const subCat = itemTags.find((t) => t.keyTags?.id === 1)?.valueTags;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/">{'\u05e2\u05de\u05d5\u05d3 \u05e8\u05d0\u05e9\u05d9'}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        {cat && (
          <>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={itemsHref({ filters: [cat.id] })}>{cat.name}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </>
        )}

        {subCat && (
          <>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={itemsHref({ filters: [subCat.id] })}>{subCat.name}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </>
        )}

        <BreadcrumbItem>
          <BreadcrumbPage>
            {'\u05de\u05e7"\u05d8'}: {uinsql}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
